__turbopack_context__.v({
  "checked": "ICf2GG_checked",
  "circle": "ICf2GG_circle",
  "placeholder": "ICf2GG_placeholder",
  "radio": "ICf2GG_radio",
  "wrapper": "ICf2GG_wrapper",
});
